import * as React from "react";
import "./ProgressBar.css";

const clamp = (min, max, value) => {
  return Math.min(Math.max(min, value), max);
};

const ProgressBar = ({ percentage }) => {
  return (
    <div className="progress-bar__container">
      <div className="progress-bar" style={{ width: `${clamp(0, 100, percentage)}%` }} />
    </div>
  );
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/share/components/ProgressBar/ProgressBar.tsx